import _ from 'lodash';
import { createRouter, createWebHashHistory } from 'vue-router';
const IM = () => import('./view/im/IM.vue');

export const router = createRouter({
  history: createWebHashHistory(''),
  routes: [
    {
      path: '/:path*',
      name: 'IM',
      component: IM,
      props: (route) => {
        return {
          defaultLocale: route.query.locale,
          apiKey: _.flatten([route.params.path]).join('/'),
        };
      },
    },
  ],
});
